import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import {
    Grid,
    Typography,
    Box,
    Skeleton,
    IconButton,
    Tooltip,
    Button,
    Paper,
    Link,
    Select,
    MenuItem,
    Menu
} from '@mui/material';
import Header from '../shared/header';
import Footer from '../shared/footer';
import ViewCardUiStore from './view-card-ui-store';
import { useParams } from 'react-router';
import { getNameFromProfileOptions, getPhoneNumberWihKey } from '../../utils/profile-utils';
import styles from './view-card.module.scss';
import {
    CallCalling,
    CloseCircle,
    Edit2,
    ExportSquare,
    People,
    Sms,
    Location,
    AddCircle,
    Global,
    TickCircle,
    Trash,
    Tag2
} from 'iconsax-react';
import RoundButton from '../shared/components/round-btn';
import { ReactComponent as MenuIcon } from '../../icons/menu.svg';
import CardSelector from './card-selector';
import ViewCatgory from './view-category';
import { categoriesNotToView } from '../../constants/general';
import DeleteCardModal from '../cards/delete-card-modal';
import ShareModal from '../cards/share-modal';
import { SocialIcon } from 'react-social-icons';
import SyncModal from './sync-modal';
import ManageContactsMenu from './managa-contacts-modal';
import UnsyncModal from '../shared/unsync-modal';
import RemoveCardModal from '../shared/remove-card-modal';
import PrivateCardHeader from './private-card-header';
import TagsModal from '../contacts/tags-modal';
import LabelModal from '../contacts/label-modal';
import ViewImgModal from '../../my-data/category/view-img-modal';
import { ReactComponent as StarIcon } from '../../icons/star.svg';

const uiStore = new ViewCardUiStore();

const ViewCard = observer(({ history, context }) => {
    const { card, languages, cards, resetCard, information, error, settings, getLabelAndDefaultCard } = uiStore;
    const { cardId, all } = useParams();
    const [name, setName] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [department, setDepartment] = useState('');
    const [company, setCompany] = useState('');
    const [location, setLocation] = useState({ lat: 10, lng: 10, zoom: 1 });
    const [selectedCard, setSelectedCard] = useState('');
    const [language, setLanguage] = useState('');
    const [showDeleteCardModal, setShowDeleteCardModal] = useState(false);
    const [connected, setConnected] = useState(false);
    const [followed, setFollowed] = useState(false);
    const [pending, setPending] = useState(false);
    const [isPrivate, setPrivate] = useState(false);
    const [showSyncModal, setShowSyncModal] = useState(false);
    const [showManageCards, setShowManageCards] = useState(false);
    const [showUnsyncModal, setShowUnsyncModal] = useState(false);
    const [showRemoveCard, setShowRemoveCard] = useState(false);
    const [defaultCard, setDefaultCard] = useState('');
    const redirectLink = '/login?redirect=/card/' + cardId;
    const [anchorEl, setAnchorEl] = useState(null);
    const [label, setLabel] = useState({});
    const [showLabelModal, setShowLabelModal] = useState(false);
    const [favorite, setFavorite] = useState(false);
    const [tags, setTags] = useState([]);
    const [update, setUpdate] = useState(false);
    const [showTagsModal, setShowTagsModal] = useState(false);
    const [showImgModal, setShowImgModal] = useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleFavirote = () => {
        uiStore.toggleFavirote(!favorite, card?._id);
        setFavorite(val => !val);
    }

    useEffect(() => {
        async function fetchData() {
            uiStore.initliazeContext(context);
            if (context.authenticatedUser.id)
                await uiStore.fetchCards(cardId);
            const data = await uiStore.fetchCard(cardId, all);
            setPending(data.pending);
            setConnected(data.connected);
            setFollowed(data.followed);
            setSelectedCard(cardId);
            setDefaultCard(cards.find(i => i.default));
            setFavorite(data?.settings?.favirote);
            setTags(data?.settings?.tags);
        }

        if (cardId)
            fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardId, context, update]);


    useEffect(() => {
        const fetchData = async () => {
            if (card) {
                const data = await getLabelAndDefaultCard(card?._id);
                setLabel(data.label);
            }
        }

        fetchData();

    }, [card, getLabelAndDefaultCard, update])

    useEffect(() => {
        setDefaultCard(cards.find(i => i.default));
    }, [cards]);

    useEffect(() => {
        if (error.includes('Private card'))
            setPrivate(true);
    }, [error]);

    const onCardChange = (id) => {
        if (id === 'All') {
            setSelectedCard(id);
            resetCard();
            history.push('/card/' + cardId + '/all');
        } else if (id !== selectedCard) {
            setSelectedCard(id);
            resetCard();
            history.push('/card/' + id);
        }
    };

    useEffect(() => {
        let lang;

        const first = languages?.find(i => i.language === settings?.firstLanguage)
        const second = languages?.find(i => i.language === settings?.secondLanguage)

        if (card?.userID === context.authenticatedUser.id) {
            lang = languages?.length ? languages[0]?.language : '';
            setLanguage(lang);
        } else if (first) {
            lang = settings.firstLanguage;
            setLanguage(settings.firstLanguage)
        } else if (second) {
            lang = settings.secondLanguage;
            setLanguage(settings.secondLanguage)
        } else {
            lang = languages?.length ? languages[0]?.language : '';
            setLanguage(lang);
        }


        if (card?._id && all && label?.name) setName(label?.name);
        else if (card?._id) setName(getNameFromProfileOptions(card, 'First Last', lang));
        else setName('-');

        if (card?.JobTitle)
            setJobTitle(card.JobTitle.infoValue[lang]);
        else setJobTitle('');

        if (card?.Field)
            setJobTitle(card.Field.infoValue[lang]);

        if (card?.Company)
            setCompany(card.Company.infoValue[lang]);
        else setCompany('');

        if (card?.Department)
            setDepartment(
                card.Department.infoValue[lang]
            );
        else setDepartment('');

        if (card?.Location) {
            const newLocation = JSON.parse(card.Location.infoValue);
            setLocation(newLocation);
        } else setLocation(null);

        if (card?.Nickname && card?.isBasic) setJobTitle(card.Nickname.infoValue[lang]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [card, languages, settings, label]);

    useEffect(() => {
        if (card?._id && all && label?.name) setName(label?.name);
        else if (card?._id) setName(getNameFromProfileOptions(card, 'First Last', language));
        else setName('-');

        if (card?.JobTitle?.infoValue)
            setJobTitle(card.JobTitle.infoValue[language]);
        else if (card?.Nickname)
            setJobTitle(card.Nickname.infoValue[language]);
        else
            setJobTitle('');

        if (card?.Field?.infoValue)
            setJobTitle(card.Field.infoValue[language]);

        if (card?.Company)
            setCompany(card.Company.infoValue[language]);
        else setCompany('');

        if (card?.Department)
            setDepartment(
                card.Department.infoValue[language]
            );
        else setDepartment('');

        if (card?.Location) {
            const newLocation = JSON.parse(card.Location.infoValue);
            setLocation(newLocation);
        } else setLocation('');


    }, [language, card, update, all, label]);

    const toggleFollow = async () => {
        if (followed) {
            setFollowed(false);
            await uiStore.updateFollow(false, cardId);

        } else {
            setFollowed(true);
            await uiStore.updateFollow(true, cardId);
        }
    }

    const unsync = async () => {
        await uiStore.unsync(cardId);
        setConnected(false);
        setFollowed(false);
    }

    const removeCard = async () => {
        await uiStore.removeCard(cardId);
        setConnected(false);
        setFollowed(false);
    }

    const afterDeleteCard = () => {
        history.push('/cards');
    }

    const cancelRequest = async () => {
        await uiStore.cancelRequest(cardId);
        setPending(false);
    }

    const setDefault = async (cardId) => {
        await uiStore.setDefaultCard(cardId);
        setDefaultCard(card);
    }

    const addCard = () => {
        if (card.allowFollowing) {
            toggleFollow();
            setConnected(true);
        }

        if (card.allowSyncing) {
            setShowSyncModal(true);
        }
    }

    const completeRequest = (t) => {
        if (!connected)
            setPending(true);
    }

    return (
        <>
            <Header
                page={
                    card
                        ? card?.userID === context.authenticatedUser.id
                            ? 'cards'
                            : 'contacts'
                        : ''
                }
            />
            <Grid className="content" container>
                {isPrivate ?
                    <PrivateCardHeader uiStore={uiStore} context={context} history={history} cardId={cardId} />
                    :
                    <Box className={styles.wrapper}>
                        <Grid container className={styles.langBar}>
                            <Grid item xl={9} lg={9} md={9} sm={9} xs={12}>
                                {connected && cards?.length > 0 &&
                                    <CardSelector
                                        card={selectedCard}
                                        onChange={onCardChange}
                                        cards={!card ? [] : card?.userID !== context.authenticatedUser.id ? [{ name: 'All', _id: 'All' }, ...cards] : cards}
                                    />
                                }
                            </Grid>
                            <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                                <Select
                                    size='small'
                                    value={language}
                                    onChange={(e) => setLanguage(e.target.value)}
                                    sx={{ borderRadius: 50, backgroundColor: 'rgb(227, 232, 239)', mt: 2.5 }}
                                    fullWidth
                                >
                                    {languages?.map((i) =>
                                        <MenuItem key={i.language} value={i.language}>{i.language}</MenuItem>
                                    )}
                                </Select>
                            </Grid>
                        </Grid>

                        <Box className={styles.cardBackground}></Box>
                        <Box className={styles.header}>
                            <Box className={styles.cardImg}>
                                {card?.image ?
                                    all && label?.img ?
                                        <Button sx={{ p: 0 }} onClick={() => setShowImgModal(true)}><img src={label?.img} alt="personal profile pic" /></Button>
                                        :
                                        <Button sx={{ p: 0 }} onClick={() => setShowImgModal(true)}><img src={card?.image} alt="personal profile pic" /></Button>
                                    : (
                                        <Skeleton
                                            variant="circular"
                                            width={150}
                                            height={150}
                                        />
                                    )}
                            </Box>
                            <ViewImgModal img={all && label?.img ? label?.img : card?.image} show={showImgModal} setShow={setShowImgModal} />
                            <Box className={styles.cardMeta}>
                                <Box>
                                    <Typography fontSize="16px" fontWeight="600">
                                        {name ? name : '-'}
                                    </Typography>
                                </Box>

                                <Box className={styles.metaContiner}>
                                    <Box className={styles.cardActions}>
                                        <Box className={styles.cardName}>
                                            <Typography fontSize="12px" fontWeight="500">
                                                {jobTitle}
                                            </Typography>
                                            <Typography fontSize="12px" fontWeight="500">
                                                {department && department}
                                                {department && company && ' - '}
                                                {company && '' + company}
                                            </Typography>
                                        </Box>

                                        <Box className={styles.connections}>
                                            <People size="24" variant="Bulk" />
                                            <Box>
                                                <Typography
                                                    fontSize="14px"
                                                    fontWeight="600"
                                                    color="#242333"
                                                >
                                                    {card?.connections ? card?.connections : 0}
                                                </Typography>
                                                <Typography fontSize="12px" fontWeight="500">
                                                    Connetions
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    {card && (
                                        <Box className={styles.actionBtns}>
                                            {card?.userID === context.authenticatedUser.id ? (
                                                <>
                                                    <RoundButton sx={{ mr: 2, mb: 2 }} href={'/edit-card/' + card?._id} variant="contained" color="whiteNav">
                                                        <Edit2 size="24" variant="Bulk" style={{ marginRight: '10px' }} />
                                                        Edit
                                                    </RoundButton>
                                                    {!card?.isBasic && (
                                                        <RoundButton variant="contained" color="whiteNav" onClick={() => setShowDeleteCardModal(true)} sx={{ mb: 2 }}>
                                                            <Trash size="24" variant="Bulk" />
                                                            Delete
                                                        </RoundButton>
                                                    )}
                                                    <ShareModal cardId={card?._id} viewCard={true} />
                                                </>
                                            ) : (
                                                <>
                                                    {/* {card?.allowFollowing && !!!all &&
                                                        <>
                                                            {followed ?
                                                                <Tooltip title='Unfollow'>
                                                                    <RoundButton onClick={toggleFollow} variant="contained" color="primary" sx={{ mb: 2 }}>
                                                                        <UserTick size="24" variant="Bulk" />
                                                                        Followed
                                                                    </RoundButton>
                                                                </Tooltip>
                                                                :
                                                                <RoundButton
                                                                    onClick={() => context.authenticatedUser.id ? toggleFollow() : history.push(redirectLink)}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    sx={{ mb: 2 }}
                                                                >
                                                                    <UserAdd size="24" variant="Bulk" />
                                                                    Follow
                                                                </RoundButton>
                                                            }
                                                        </>
                                                    } */}
                                                    {connected || followed ?
                                                        all
                                                            ?
                                                            <></>
                                                            :

                                                            <Tooltip title='Remove Card'>
                                                                <RoundButton onClick={() => setShowRemoveCard(true)} variant="contained" color="primary" sx={{ mb: 2 }}>
                                                                    <TickCircle size="24" variant="Bulk" />
                                                                    Added
                                                                </RoundButton>
                                                            </Tooltip>
                                                        :
                                                        pending ?
                                                            <Tooltip title='Cancel Request'>
                                                                <RoundButton variant="contained" color="primary" sx={{ mb: 2 }} onClick={cancelRequest}>
                                                                    <CloseCircle size="24" variant="Bulk" />
                                                                    Pending
                                                                </RoundButton>
                                                            </Tooltip>
                                                            :
                                                            !!(card?.allowSyncing || card?.allowFollowing) && !!!all &&
                                                            <RoundButton
                                                                onClick={() => context.authenticatedUser.id ? addCard() : history.push(redirectLink)}
                                                                variant="contained"
                                                                olor="primary"
                                                                sx={{ mb: 2 }}
                                                            >
                                                                <AddCircle size="24" variant="Bulk" />
                                                                Add Card
                                                            </RoundButton>
                                                    }
                                                    <ShareModal cardId={card?._id} viewCard={true} />
                                                    {(connected || all || followed) &&
                                                        <Tooltip title="Options">
                                                            <IconButton
                                                                variant="contained"
                                                                className={styles.small}
                                                                onClick={handleClick}
                                                            >
                                                                <MenuIcon width={20} height={20} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        id="account-menu"
                                                        open={open}
                                                        onClose={handleClose}
                                                        onClick={handleClose}
                                                        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                                                        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                                                        PaperProps={{
                                                            elevation: 0,
                                                            sx: {
                                                                borderRadius: "8px",
                                                                boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.07)',
                                                                paddingTop: 0,
                                                                mt: 2
                                                            },
                                                        }}
                                                    >
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', m: '8px 50px' }}>
                                                            <Tooltip title="Edit label">
                                                                <IconButton onClick={() => setShowLabelModal(true)}>
                                                                    <Edit2
                                                                        size="22"
                                                                        variant="Bulk"
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Tags">
                                                                <IconButton onClick={() => setShowTagsModal(true)}>
                                                                    {tags?.length > 0 ?
                                                                        <Tag2
                                                                            size="24"
                                                                            variant="Bulk"
                                                                            color="#02B28E"
                                                                        />
                                                                        :
                                                                        <Tag2
                                                                            size="24"
                                                                            variant="Bulk"
                                                                        />
                                                                    }
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Favorite">
                                                                <IconButton onClick={toggleFavirote}>
                                                                    {favorite ?
                                                                        <StarIcon
                                                                            width="20"
                                                                            height="20"
                                                                            fill="#FFB300"
                                                                        />
                                                                        :
                                                                        <StarIcon
                                                                            width="18"
                                                                            height="18"
                                                                            fill="#888"
                                                                        />
                                                                    }
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                        {/* <MenuItem onClick={toggleFavirote} fontSize={12}>{favorite ? 'Unfavorite' : 'Make Favirote'}</MenuItem>
                                                        {all && <MenuItem onClick={() => setShowLabelModal(true)} fontSize={12}>Edit Label</MenuItem>}
                                                        <MenuItem onClick={() => setShowTagsModal(true)} fontSize={12}>Tags ( {tags?.length} )</MenuItem> */}
                                                        {defaultCard?._id !== cardId && !all &&
                                                            <MenuItem onClick={() => setDefault(cardId)} fontSize={12}>Set default</MenuItem>
                                                        }
                                                        <MenuItem onClick={() => setShowManageCards(true)} fontSize={12}>Manage Connection </MenuItem>
                                                        <MenuItem onClick={() => setShowUnsyncModal(true)} fontSize={12}>Delete Contact</MenuItem>
                                                    </Menu>
                                                </>
                                            )}
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Box>

                        <Grid container sx={{ mt: 3 }} spacing={2}>
                            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                                {(card?.Number ||
                                    card?.Email ||
                                    card?.Socials?.length ||
                                    card?.Website ||
                                    location) && (
                                        <Paper variant='round' sx={{ padding: '20px', mb: 2 }}>
                                            {card?.Number &&
                                                <Box sx={{ display: 'flex', mb: 2 }}>
                                                    <CallCalling size="24" variant="Bulk" />
                                                    <Link href={'tel:' + getPhoneNumberWihKey(card?.Number)}>
                                                        <Typography sx={{ ml: 1 }} fontSize={14}>
                                                            {getPhoneNumberWihKey(card?.Number)}
                                                        </Typography>
                                                    </Link>
                                                </Box>
                                            }
                                            {card?.Email &&
                                                <Box sx={{ display: 'flex', mb: 2 }}>
                                                    <Sms size="24" variant="Bulk" />
                                                    <Link href={'mailto:' + card?.Email?.infoValue}>
                                                        <Typography sx={{ ml: 1 }} fontSize={14}>{card?.Email?.infoValue}</Typography>
                                                    </Link>
                                                </Box>
                                            }
                                            {!!card?.Website &&
                                                <Box sx={{ display: 'flex', mb: 2 }}>
                                                    <Global size="24" variant="Bulk" />
                                                    <Link rel='noopener noreferrer' target="_blank" href={card?.Website?.infoValue}>
                                                        <Typography
                                                            sx={{
                                                                ml: 1, maxWidth: '180px', textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap', overflow: 'hidden'
                                                            }}
                                                            fontSize={14}
                                                        >
                                                            {card?.Website?.infoValue}
                                                        </Typography>
                                                    </Link>
                                                </Box>
                                            }
                                            {!!location && (
                                                <>
                                                    <Location size="24" variant="Bulk" />
                                                    <Button
                                                        endIcon={<ExportSquare size="18" variant="Outline" />}
                                                        href={`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`}
                                                        target="_blank"
                                                        rel='noopener noreferrer'
                                                        color="greyPrimary"
                                                        sx={{ fontSize: 12, mt: -1.5 }}
                                                    >
                                                        View Location
                                                    </Button>
                                                </>
                                            )}
                                            {!!card?.socials?.length &&
                                                <Box sx={{ mt: 2 }}>
                                                    <Typography fontSize={14} fontWeight={600} sx={{ mb: 1 }}>Social Media Accounts</Typography>
                                                    {card.socials?.map(social =>
                                                        <IconButton key={social._id} href={social.infoValue} rel='noopener noreferrer' target="_blank">
                                                            <SocialIcon network={social.section.name.toLowerCase()} style={{ height: 24, width: 24 }} />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                            }
                                        </Paper>
                                    )}

                                {information?.map(
                                    (category) => {
                                        const infos = category.data.infos.filter(i => i.infoLanguage === language);
                                        return (
                                            !!(categoriesNotToView.includes(category.name) && category.name !== 'Name' && infos.length) &&
                                            <ViewCatgory category={category} infos={infos} uiStore={uiStore} />
                                        )
                                    }
                                )}
                            </Grid>
                            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
                                {information?.map(
                                    (category) => {
                                        const infos = category.data.infos.filter(i => i.infoLanguage === language);

                                        return (
                                            !!(!categoriesNotToView.includes(category.name) && infos.length) &&
                                            <ViewCatgory key={category._id} category={category} infos={infos} uiStore={uiStore} />
                                        )
                                    }
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                }
            </Grid >
            <SyncModal show={showSyncModal} setShow={setShowSyncModal} uiStore={uiStore} cardId={cardId} setPending={completeRequest} context={context} />
            <DeleteCardModal show={showDeleteCardModal} setShow={setShowDeleteCardModal} uiStore={uiStore} card={card} afterDeleteCard={afterDeleteCard} />
            <ManageContactsMenu show={showManageCards} setShow={setShowManageCards} uiStore={uiStore} cardId={cardId} />
            <UnsyncModal show={showUnsyncModal} setShow={setShowUnsyncModal} card={card} unsync={unsync} />
            <RemoveCardModal show={showRemoveCard} setShow={setShowRemoveCard} card={card} removeCard={removeCard} />
            <Footer></Footer>
            {
                card &&
                <LabelModal
                    uiStore={uiStore}
                    setShow={setShowLabelModal}
                    show={showLabelModal}
                    card={card}
                    label={label}
                    cardName={getNameFromProfileOptions(card, settings?.nameFormat, language)}
                    updateModal={() => setUpdate(val => !val)}
                />
            }
            {
                card &&
                <TagsModal
                    uiStore={uiStore}
                    setShow={setShowTagsModal}
                    show={showTagsModal}
                    card={card}
                    setTags={setTags}
                    tags={tags}
                />
            }
        </>
    );
});

export default ViewCard;
